import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBJumbotron } from 'mdbreact';
 
import { Form, Input, Button, Checkbox,Radio,Select } from 'antd';
import Login from './Login';
import Axios from 'axios'
import { URL } from '../api';
import Swal from 'sweetalert2'
import dsd from '../img/bn.jpg'

function onBlur() {
  console.log('blur');
}

function onFocus() {
  console.log('focus');
}

function onSearch(val) {
  console.log('search:', val);
}

const { Option } = Select;

export default class Register extends Component {
    
    //    state = {
    //       Username: "",
    //       Password: "",
    //       loading: true,
    //       login_error: true,
    //       login_error2: true,
    //       login_error3: true,
    //     }
  
        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,


                province : '', //idจังหวัด
                provincename : '', //ชื่อจังหวัด
                amper : '', //idอำเภอ
                ampername : '', //ชื่ออำเภอ
                district : '', //idตำบล
                districtname : '', //ชื่อตำบล
                zipcode : '', //รหัสไป

                //ข้อมูลตัวเลือกส่วนตัว
                PROVINCE :[],
                AMPHUR :[],
                DISTRICT:[],

                //ข้อมูลตัวเลือกอาชีพ
                AMPHURPT:[],
                DISTRICT:[],


                register_typemamber :'', //ประเภทผู้ลงทะเบียน
                register_email : '', //email
                register_pass : '', //รหัสผ่าน
                register_pass2: '', //ยืนยันรหัสผ่าน
                register_oldpass: '', //รหัสผ่าน
                register_nameth: '', //ชื่อ
                register_lnameth: '', //นามสกุล
                register_pname: '', //คำนำหน้า
                register_nameen: '', //ชื่อภาษาอังกฤษ
                register_lnameen: '', //นามสกุลอังกฤษ
                register_sex: '', //เพศ
                register_numhome: '', //บ้านเลขที่
                register_moo: '', //หมู่
                register_street: '', //ถนน
                register_soi: '', //ซอย
                register_private: '', //จังหวัด
                register_ditric:'',//อำเภอ
                register_subdritic:'',//ตำบล
                register_zipcode:'',//รหัสไปรษณีย์
                register_phone:'', //เบอร์โทร
                register_date:'', //วันที่ลงทะเบียน
                register_activate:'1', // อนุมัติ
                register_status:'1', //สถานะผู้ลง

            };
            this.handleChange = this.handleChange.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
          
            this.toggle = this.toggle.bind(this);

            this.handleprovince = this.handleprovince.bind(this)
            this.handleamphur = this.handleamphur.bind(this)
            this.handledistrict = this.handledistrict.bind(this)
            this.handleChangetgender = this.handleChangetgender.bind(this)
            this.handleChangetype = this.handleChangetype.bind(this)
            this.handleSubmit = this.handleSubmit.bind(this)
            

          }


          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }
        
          handleChange(event) {     this.setState({[event.target.name]: event.target.value});   } 
          handleChangetype(event) {    this.setState({register_typemamber: event.target.value});  }
          handleChangetgender(event) {    this.setState({register_sex: event.target.value});  }
          handleChange2(event) {    this.setState({Psaaword: event.target.value});  }

          handleSubmit= (e) => {
            e.preventDefault();
            // alert('A name was submitted: ' + this.state.value);
            const date = new Date();
            const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
            const dates = day+"-"+month+"-"+year ;
                  setTimeout(() => {

                      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                      datafrm.append("register_typemamber", this.state.register_typemamber);
                      datafrm.append("register_email", this.state.register_email);
                      datafrm.append("register_pass", this.state.register_pass);
                      datafrm.append("register_oldpass", this.state.register_pass2);
                      datafrm.append("register_nameth", this.state.register_nameth);
                      datafrm.append("register_lnameth", this.state.register_lnameth);
                      datafrm.append("register_pname", this.state.register_pname);
                      datafrm.append("register_nameen", this.state.register_nameen);
                      datafrm.append("register_lnameen", this.state.register_lnameen);
                      datafrm.append("register_sex", this.state.register_sex);
                      datafrm.append("register_numhome", this.state.register_numhome);
                      datafrm.append("register_moo", this.state.register_moo);
                      datafrm.append("register_street", this.state.register_street);
                      datafrm.append("register_soi", this.state.register_soi);
                      datafrm.append("register_private", this.state.province);
                      datafrm.append("register_ditric", this.state.amper);
                      datafrm.append("register_subdritic", this.state.district);
                      datafrm.append("register_zipcode", this.state.register_zipcode);
                      datafrm.append("register_phone", this.state.register_phone);
                      datafrm.append("register_date", dates);
                      datafrm.append("register_activate", this.state.register_activate);
                      datafrm.append("register_status", this.state.register_status);

                  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/insertregister.php",datafrm,{
                //  Axios.post("https://conference.kpru.ac.th/PHPAPI/uploadcomment1show.php",datafrm,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                  })
                
                  .then(res => {
                    console.warn(res);
                    console.log("response: ", res)

                    if (res.data.length !== 0) {
                      console.log(res)
                      console.log(res.data.length) 
                    }else{
                    // window.location.href = '/'
                    }
                
                
                    if (res.status = 200) {
                    //  message.success("อัพโหลไฟล์สำเร็จ")
                     // this.setState({ id_send: ""})
                    // window.location.href = '/adminfaculty'
                    Swal.fire({
                      title: 'ลงทะเบียนสำเร็จ',
                      text: "Successfully registered",
                      icon: 'success',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#d33',
                      confirmButtonText: 'ตกลง'
                    }).then((result) => {
                      if (result.isConfirmed) {
                         
                          window.location.reload(false);
                        //  this.toggle()
                      }
                    })


                    }else{
                   //   message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                    }
                
                  })
                
                }, 1000);
     
          }

          componentDidMount() {
              setTimeout(() => {
                //จังหวัด
                 Axios.get('https://edu.kpru.ac.th/conference/phpapi/selectprovinces.php')
                .then(res => {
                //  console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                const data = res.data
                const options = data.map(d => ({
                    "value" : d.PROVINCE_ID,
                    "label" : d.PROVINCE_NAME
                  }))
                  this.setState({ PROVINCE: options})
                }) 
              }, 0);
          }

             //จังหวัดข้อมูลส่วนตัว
           handleprovince(e,u){
          // console.log(u)
           this.setState({province:u.value, provincename:u.label})
           setTimeout(() => {
               //จังหวัด
                Axios.get('https://edu.kpru.ac.th/conference/phpapi/selectamphures.php?PROVINCE_ID='+u.value)
               // Axios.get('http://localhost/phpapi/selectamphures.php?PROVINCE_ID='+u.value)
               .then(res => {
             //    console.log(res);
               //  this.setState({ bankname: res.data, loading: false })
               const data = res.data
               const optionsam = data.map(a => ({
                   "value" : a.AMPHUR_ID,
                   "label" : a.AMPHUR_NAME
                 }))
                 this.setState({ AMPHUR: optionsam})
               }) 
             }, 0);
          }

          //อำเภอข้อมูลส่วนตัว
          handleamphur(e,u){
           // console.log(u)
            this.setState({amper:u.value, ampername:u.label})
            setTimeout(() => {
                //จังหวัด
                 Axios.get('https://edu.kpru.ac.th/conference/phpapi/selectdistricts.php?AMPHUR_ID='+u.value)
               //  Axios.get('http://localhost/phpapi/selectdistricts.php?AMPHUR_ID='+u.value)
                .then(res => {
                 // console.log(res);
                //  this.setState({ bankname: res.data, loading: false })
                const data = res.data
                const optionsds = data.map(a => ({
                    "value" : a.DISTRICT_CODE,
                    "label" : a.DISTRICT_NAME
                  }))
                  this.setState({ DISTRICT: optionsds})
                }) 
              }, 0);

              Axios.get('https://edu.kpru.ac.th/conference/phpapi/selectzipcode.php?AMPHUR_ID='+u.value)
              //  Axios.get('http://localhost/phpapi/selectdistricts.php?AMPHUR_ID='+u.value)
               .then(res => {
                 console.log(res.data[0].POST_CODE);
               //  this.setState({ bankname: res.data, loading: false })
               const data = res.data
              //  const optionsds = data.map(a => ({
              //      "value" : a.DISTRICT_CODE,
              //      "label" : a.DISTRICT_NAME
              //    }))
                  this.setState({ register_zipcode: res.data[0].POST_CODE})
               }) 
          }

            //ตำบลข้อมูลส่วนตัว
            handledistrict(e,u){
           // console.log(u)
            this.setState({district:u.value, districtname:u.label})

            // setTimeout(() => {
               
            //     //จังหวัด
            //      Axios.get('https://thenextth.com/registerfa/selectzipcode.php?DISTRICT_CODE='+u.value)
            //     // Axios.get('http://localhost/phpapi/selectzipcode.php?DISTRICT_CODE='+u.value)
            //     .then(res => {
            //   //    console.log(res);
            //     //  this.setState({ bankname: res.data, loading: false })
            //     //const data = res.data[0].zipcode
            //    //  const optionsds = data.map(a => ({
            //    //      "value" : a.DISTRICT_ID,
            //    //      "label" : a.DISTRICT_NAME
            //    //    }))
            //       this.setState({ zipcode: res.data[0].zipcode})
            //     }) 
            //   }, 0);
           }



    render() {

      console.log(this.state.register_moo)
      console.log(this.state.amper)

        return (
          <MDBContainer className="mt-1 ">
                <div className='mt-1'>
                 <img src={dsd} className="rounded  d-block "alt="aligment" />
              </div>
         
              <MDBJumbotron >
              <div className='text-center'>
                <h2 >ลงทะเบียน</h2>
                <p className="lead">
                การประชุมวิชาการะดับชาติ ครุศาสตร์ศึกษา ครั้งที่ 8 
                </p>
               
                
                </div>
                <hr className="my-2" />


                <form onSubmit={this.handleSubmit} >
                           
                              <div className="mb-2">
                                <label rules={[{ required: true }]}></label>ประเภทผู้ลงทะเบียน<label className="red-text">*</label><br/>
                            
                                <Radio.Group onChange={this.handleChangetype} required={true}  >
                                <Radio value="4">นักศึกษา (ภายใน) มหาวิทยาลัยาชภัฏกำแพงเพชร</Radio><br/>
                                <Radio value="6">บุคลากรภายใน (ภายใน) มหาวิทยาลัยาชภัฏกำแพงเพชร</Radio><br/>
                                <Radio value="5">นักศึกษา (ภายนอก) มหาวิทยาลัยาชภัฏกำแพงเพชร</Radio><br/>
                                <Radio value="7">บุคลากรทั่วไป (ภายนอก) มหาวิทยาลัยาชภัฏกำแพงเพชร</Radio>
                               
                                </Radio.Group>
                            </div>

                            <div className="mb-2">
                                <label>e-mail</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_email" 
                                    value={this.state.register_email} placeholder="กรุณาระบุ e-mail" required />
                            </div>

                            <div className="mb-2">
                                <label>รหัสผ่าน</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_pass"
                                    value={this.state.register_pass} placeholder="กรุณาระบุ รหัสผ่าน" required />
                            </div>
                            <div className="mb-2">
                                <label>ยืนยันรหัสผ่าน</label><label className="red-text">* </label> 
                                {this.state.register_pass2 !== ''?<>
                                 {this.state.register_pass !== this.state.register_pass2 ?<><label className="red-text">รหัสผ่านไม่ตรงกัน </label></>:<></>}
                                </>:<></>}
                               
                                <input  className="form-control" onChange={this.handleChange} name="register_pass2"
                                    value={this.state.register_pass2} placeholder="กรุณาระบุ ยืนยันรหัสผ่าน" required />
                            </div>
                            <div className="mb-2">
                                <label>คำนำหน้า</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_pname"
                                    value={this.state.register_pname} placeholder="กรุณาระบุ คำนำหน้า" required />
                            </div>

                            <MDBRow>
                              <MDBCol lg="6">
                                <div className="mb-2">
                                <label>ชื่อ (ภาษาไทย) </label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_nameth"
                                    value={this.state.register_nameth} placeholder="กรุณาระบุ ชื่อ (ภาษาไทย)" required />
                                </div>
                            </MDBCol>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label>นามสกุล (ภาษาไทย) </label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_lnameth"
                                    value={this.state.register_lnameth} placeholder="กรุณาระบุ นามสกุล (ภาษาไทย)" required />
                                </div>
                              </MDBCol>
                            </MDBRow>

                            <MDBRow>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label>ชื่อ (ภาษาอังกฤษ)</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_nameen"
                                    value={this.state.register_nameen} placeholder="กรุณาระบุ ชื่อ (ภาษาอังกฤษ)" required />
                              </div>
                              </MDBCol>
                              <MDBCol lg="6">
                              <div className="mb-2">
                                <label>นามสกุล (ภาษาอังกฤษ)</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_lnameen"
                                    value={this.state.register_lnameen} placeholder="กรุณาระบุ นามสกุล (ภาษาอังกฤษ)" required />
                            </div>
                                </MDBCol>
                            </MDBRow>

                            
                           
                          <div className="mb-2">
                                <label rules={[{ required: true }]}></label>เพศ<label className="red-text">*</label><br/>
                            
                                <Radio.Group onChange={this.handleChangetgender} required={true} >
                                <Radio value="1">ชาย</Radio>
                                <Radio value="2">หญิง</Radio>
                               
                                </Radio.Group>
                            </div>
                            <div className="mb-2">
                                <label>บ้านเลขที่</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_numhome"
                                    value={this.state.register_numhome} placeholder="กรุณาระบุ บ้านเลขที่" required />
                            </div>
                            <div className="mb-2">
                                <label>หมู่</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_moo"
                                    value={this.state.register_moo} placeholder="กรุณาระบุ หมู่" required />
                            </div>
                            <div className="mb-2">
                                <label>ถนน</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_street"
                                    value={this.state.register_street} placeholder="กรุณาระบุ ถนน" required />
                            </div>
                            <div className="mb-2">
                                <label>ซอย</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_soi"
                                    value={this.state.register_soi} placeholder="กรุณาระบุ ซอย" required />
                            </div>
                          
                                <label>จังหวัด</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ จังหวัด"  className="browser-default custom-select " options={this.state.PROVINCE}  onChange={this.handleprovince.bind(this)} required/><br/>

                                <label>อำเภอ</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ อำเภอ"  className="bbrowser-default custom-select " options={this.state.AMPHUR}  onChange={this.handleamphur.bind(this)} required/>

                                <label>ตำบล</label><label className="red-text">*</label>
                                <Select placeholder="กรุณาระบุ ตำบล"  className="bbrowser-default custom-select " options={this.state.DISTRICT}  onChange={this.handledistrict.bind(this)} required/>

                                <label>รหัสไปษณีย์</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_zipcode"
                                value={this.state.register_zipcode} placeholder="กรุณาระบุ รหัสไปษณีย์" required />

                            <div className="mb-2">
                                <label>เบอร์โทร</label><label className="red-text">*</label>
                                <input  className="form-control" onChange={this.handleChange} name="register_phone"
                                    value={this.state.register_phone} placeholder="กรุณาระบุ เบอร์โทร" required />
                            </div>

                <div className='text-center'>

             
                                 {this.state.register_pass !== this.state.register_pass2 ?<><label className="red-text"><p>รหัสผ่านไม่ตรงกัน</p> <MDBBtn color="primary" type='submit' disabled >ลงทะเบียน</MDBBtn> </label></>:<> <MDBBtn color="primary" type='submit' >ลงทะเบียน</MDBBtn> </>}
                             
                  {/* <MDBBtn color="primary" type='submit' >ลงทะเบียน</MDBBtn>  */}
                  </div>
                  
                </form>
              </MDBJumbotron>
         
        </MDBContainer>
        )
    }
}
